<template>
  <div id="app">
    <navbar v-if="$route.meta.auth"/>
    <div :class="{'margin-top-navbar' : $route.meta.auth}" class="container-fluid p-0">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    navbar: () => import("@/components/navbar"),
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Poppins");

* {
  font-family: "Poppins";
}

body {
  background-color: #f1f1f1 !important;
}

.vs-input {
  width: 100% !important
}

.vs-button {
  margin: 0 !important;
}

.vs-card {
  max-width: 100% !important;
}

.vs-card__img {
  max-height: 100% !important;
}

.margin-top-navbar {
  margin-top: 65px;
}

.container-fluid {
  overflow: hidden;
}
</style>